import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';

function useDynamicLottiePlayer() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    LottiePlayer = _useState2[0],
    setLottiePlayer = _useState2[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    import('@lottiefiles/react-lottie-player').then(function (module) {
      setLottiePlayer(function () {
        return module.Player;
      });
    })["catch"](function (err) {
      console.error('Failed to load Lottie Player', err);
    });
  }, []);
  return LottiePlayer;
}

export { useDynamicLottiePlayer };
//# sourceMappingURL=useDynamicLottiePlayer.js.map
